const MK_LETTERS_TO_MYSELF_1799_PRODUCT = 'mkLettersToMyself1799';

export {
    MK_LETTERS_TO_MYSELF_1799_PRODUCT
};
